import React from "react"
import { Collapse } from "antd"

// @ts-ignore
import { SCROLLABLE_AUTHORING_CONTAINER } from "constants/authoring.js"

// @ts-ignore
import { ValidationMessage } from "components-design-system"
// @ts-ignore
import scrollToElement from "utilities/scrollToElement"
import "./ValidationWrapper.scss"

const resultsSectionHeaders = [
  "results_participant_flow",
  "results_baseline_characteristics",
  "results_outcome_measures",
  "results_adverse_events",
]

export default function ValidationWrapper({ messages, type }: { messages: any; type: string }) {
  const classNames = ["validation-msg"]
  const isMapped = type === "mapped"

  const onScrollToField = (targetId: string) => {
    if (isMapped) {
      const elements = document.getElementsByClassName(SCROLLABLE_AUTHORING_CONTAINER.FORM_CLASSNAME)
      const scrollableElement: HTMLElement | null = elements.length > 0 ? (elements[0] as HTMLElement) : null

      let targetElement: HTMLElement | null = document.getElementById(targetId)
      if (!targetElement) {
        targetElement = document.getElementById(`root_${targetId}`)
      }

      if (!targetElement) {
        for (const header of resultsSectionHeaders) {
          if (targetId.includes(header)) {
            targetElement = document.getElementById(`root_${header}`)
          }
        }
      }

      if (targetElement) {
        scrollToElement({ scrollableElement, targetElement, scrollType: "instant", offsetTop: 100 })
      }
    }
  }

  if (isMapped) classNames.push("mapped-validation")

  const renderMessage = (message: any) => {
    return (
      <div
        className={classNames.join(" ")}
        style={{ cursor: "pointer" }}
        key={`${message.field_key}-${message.text}`}
        onClick={() => onScrollToField(`${message.field_key}`)}
      >
        <ValidationMessage
          tooltip={message?.source || message?.field_key}
          type={message?.type?.toLowerCase() || "error"}
          value={message.text}
        />
      </div>
    )
  }

  const renderValidations = React.useMemo(() => {
    const commonMap: any = {}

    messages.forEach((message: any) => {
      const text = message.text

      if (commonMap[text]) {
        commonMap[text].push(message)
      } else {
        commonMap[text] = [message]
      }
    })

    return Object.keys(commonMap).map((key, i) => {
      const vals = commonMap[key]
      const message = vals[0]

      if (vals.length === 1) {
        return renderMessage(message)
      } else {
        return (
          <Collapse
            key={i}
            bordered={false}
            expandIcon={({ isActive }) => <i className={`fa-light fa-angle-${isActive ? "down" : "right"}`} />}
            style={{ background: "transparent" }}
            items={[
              {
                key: message.text,
                label: `(${vals.length}) ${message.text}`,
                children: vals.map((val: any, i: any) => renderMessage(val)),
              },
            ]}
          />
        )
      }
    })
  }, [messages])

  return <div className="validation-wrapper">{renderValidations}</div>
}
